module.exports = __webpack_public_path__ + "static/media/plus-square.6f3a7f73.svg";